module.exports = __webpack_public_path__ + "static/media/climbing-person-rock-climbing-svgrepo-com.58a1915f.svg";